/* eslint-disable camelcase */
import { getTeamLabelByNumber } from '../../utils/utils'

let shootoutStartingSideFlag = false

export default {
  // 'this' - $store
  byActionType: {
    numberOfPlayersChangeEvents ({ extra: { team1, team2 } }) {
      this.setIngameProperty({
        property: 'playersCount',
        value: {
          home: team1,
          away: team2
        }
      })
    }
  },
  // 'this' - $store
  byEventType: {
    'MATCH_FORMAT' (event) {
      const { isShootoutSeriesFormat } = this
      const { extra } = event
      const {
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat: firstVersionTimerFormats,
        has_golden_set,
        inverse,
        timer_speed_up: timerSpeedUp,
        is_shootout_series_format
      } = extra
      const timerFormat = !firstVersionTimerFormats
        ? {
          inverse,
          resetEachPeriod: true
        }
        : firstVersionTimerFormats

      if (isShootoutSeriesFormat) return

      this.setMatchFormat({
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat,
        timerSpeedUp,
        has_golden_set
      })

      if (!is_shootout_series_format) return

      this.setShootoutSeriesFormat()
    },
    'INNER_SYNC_EVENT' ({ GamePeriod, ScoreHome, ScoreAway, extra: { team1, team2, is_shootout } }) {
      const { getMatchPeriods } = this
      const { [GamePeriod]: currentPeriod } = getMatchPeriods
      const { overriddenType } = currentPeriod

      this.setIngameProperty({
        property: 'playersCount',
        value: {
          home: team1,
          away: team2
        }
      })

      if (
        !is_shootout ||
        (overriddenType && overriddenType === 'shootout')
      ) return

      shootoutStartingSideFlag = true
    },
    'LEFT_SIDE_TEAM' ({ TeamNumber }) {
      this.setIngameProperty({
        property: 'leftSideTeam',
        value: TeamNumber
      })
    },
    'START_PERIOD' ({ GamePeriod, extra: { team1, team2 } }) {
      if (GamePeriod === 1) return

      const { getIngameData } = this
      const { leftSideTeam } = getIngameData

      this.setIngameProperty({
        property: 'leftSideTeam',
        value: leftSideTeam === 1 ? 2 : 1
      })

      this.setIngameProperty({
        property: 'playersCount',
        value: {
          home: team1,
          away: team2
        }
      })
    },
    'START_OVERTIME_PERIOD' ({ extra: { team1, team2 } }) {
      const { getIngameData } = this
      const { leftSideTeam } = getIngameData

      this.setIngameProperty({
        property: 'leftSideTeam',
        value: leftSideTeam === 1 ? 2 : 1
      })

      this.setIngameProperty({
        property: 'playersCount',
        value: {
          home: team1,
          away: team2
        }
      })
    },
    'GOAL' (event) {
      const { GamePeriod, TeamNumber } = event
      const { getMatchPeriods } = this
      const { overriddenType } = getMatchPeriods[GamePeriod]
      const isShootoutPeriod = overriddenType === 'shootout'

      if (isShootoutPeriod) {
        this.updateShootoutStatistic({
          team: getTeamLabelByNumber(TeamNumber),
          value: true
        })
      } else {
        this.setScore(event)
      }
    },
    'SHOOTOUT_MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })
    },
    'START_SHOOTOUT' (event) {
      shootoutStartingSideFlag = false

      this.setPenaltyShootouts(event)
    },
    'FINISH_OVERTIME_PERIOD' (event) {
      const { getMatchPeriods } = this
      const { extra: { is_shootout, team1, team2 }, GamePeriod } = event
      const { [GamePeriod]: currentPeriod } = getMatchPeriods
      const { overriddenType } = currentPeriod

      this.setIngameProperty({
        property: 'playersCount',
        value: {
          home: team1,
          away: team2
        }
      })

      if (
        !is_shootout ||
        (overriddenType && overriddenType === 'shootout')
      ) return

      this.setPeriod({ GamePeriod: event.GamePeriod, ScoreHome: event.ScoreHome, ScoreAway: event.ScoreAway })
      this.setPenaltyShootouts({ GamePeriod: event.GamePeriod })
    },
    'FINISH_PERIOD' (event) {
      const { getMatchPeriods } = this
      const { extra: { is_shootout }, GamePeriod } = event
      const { [GamePeriod]: currentPeriod } = getMatchPeriods
      const { overriddenType } = currentPeriod

      this.setTimer(event)

      if (
        !is_shootout ||
        (overriddenType && overriddenType === 'shootout')
      ) return

      this.setPenaltyShootouts(event)
    },
    'FINISH_GAME' (event) {
      const { getCurrentPeriod, getMatchPeriods } = this
      const { overriddenType } = getMatchPeriods[getCurrentPeriod]
      const isShootoutPeriod = overriddenType === 'shootout'

      if (isShootoutPeriod) {
        this.editPeriodScore(event)
      }

      this.setWinner(event)
    },
    'CANCEL' (event) {
      const { RelatedEventNumber, GamePeriod } = event
      const { getEventCache, getCurrentPeriod, getMatchPeriods } = this
      const relatedEvent = getEventCache[RelatedEventNumber]
      const { EventCode, TeamNumber, extra: { team1, team2 } } = relatedEvent
      const { overriddenType } = getMatchPeriods[getCurrentPeriod]
      const isShootoutPeriod = overriddenType === 'shootout'

      if (['GOAL', 'SHOOTOUT_MISS'].includes(EventCode) && isShootoutPeriod) {
        this.updateShootoutStatistic({
          team: getTeamLabelByNumber(TeamNumber),
          type: 'delete'
        })
      }

      if (EventCode === 'FINISH_PERIOD') {
        this.setEventLogPeriod(GamePeriod)
        this.setStatisticPeriod(GamePeriod)
        this.setCurrentPeriod(GamePeriod)
      }

      if (EventCode === 'START_SHOOTOUT') {
        shootoutStartingSideFlag = true

        this.deletePenaltyShootoutFlag(getCurrentPeriod)
        this.clearShootoutFlag()
        this.setEventLogPeriod(getCurrentPeriod)
        this.setStatisticPeriod(getCurrentPeriod)
      }

      if (EventCode === 'START_OVERTIME_PERIOD') {
        this.setIngameProperty({
          property: 'playersCount',
          value: {
            home: team1,
            away: team2
          }
        })
      }
      if (EventCode === 'FINISH_OVERTIME_PERIOD') {
        shootoutStartingSideFlag = false
      }

      if (EventCode === 'GOAL') {
        this.setScore(event)
      }

      this.setCanceled(event)
      this.refreshDelayedEvents(event)
    }
  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {
    'START_SHOOTOUT' () {
      return this.$t('trader.shootout.start.bullets')
    },
    'ADJUST_POINTS' () {
      return this.$t('hockey.adjust.points')
    },
    'FACE_OFF' (event) {
      if (!event.eventInfo) return ''

      const { extra: { point } } = event

      return `${event.eventInfo.title} / ${this.$t('hockey.face.off.point')}: ${point}`
    },
    /**
     * @return {string}
     */
    'POSESSION_1' (event) {
      const { GamePeriod } = event
      const { getMatchPeriods, homeTeamTitle, getEventCacheList } = this
      const { overriddenType } = getMatchPeriods[GamePeriod]

      if (shootoutStartingSideFlag) {
        return `${this.$t('hockey.shootout.starting.side.title')} / ${homeTeamTitle}`
      }

      if (overriddenType === 'shootout') {
        return `${this.$t('hockey.shootout.possession.title')} / ${homeTeamTitle}`
      }

      if (!event.eventInfo) return ''

      return `${event.eventInfo.title} / ${homeTeamTitle}`
    },
    /**
     * @return {string}
     */
    'POSESSION_2' (event) {
      const { GamePeriod } = event
      const { getMatchPeriods, awayTeamTitle, getEventCacheList } = this
      const { overriddenType } = getMatchPeriods[GamePeriod]

      if (shootoutStartingSideFlag) {
        return `${this.$t('hockey.shootout.starting.side.title')} / ${awayTeamTitle}`
      }

      if (overriddenType === 'shootout') {
        return `${this.$t('hockey.shootout.possession.title')} / ${awayTeamTitle}`
      }

      if (!event.eventInfo) return ''

      return `${event.eventInfo.title} / ${awayTeamTitle}`
    },
    /**
     * @return {string}
     */
    'FINISH_GAME' (event) {
      const { GamePeriod } = event
      const { getMatchPeriods, homeTeamTitle, awayTeamTitle, getWinner } = this
      const { type, overriddenType } = getMatchPeriods[GamePeriod]
      const teamTitle = getWinner === 'home' ? homeTeamTitle : awayTeamTitle

      if (getWinner === 'draft') {
        return `${this.$t('trader.gameover')} / ${this.$t('trader.draw.capitalized')}`
      }

      if (overriddenType === 'shootout') {
        return `${this.$t('trader.gameover')} / ${teamTitle} ${this.$t('trader.win.bullets')}`
      }

      if (type === 'overtime') {
        return `${this.$t('trader.gameover')} / ${teamTitle} ${this.$t('trader.win.overtime')}`
      }

      return `${this.$t('trader.gameover')} / ${teamTitle} ${this.$t('trader.win.maintime')}`
    }
  },
  eventClasses: {
    /**
     * @return {string}
     */
    'ADDITIONAL_TIME' ({ extra: { minutes } }) {
      if (!minutes) return ''

      return '_green'
    }
  },
  customVictoryTitle (event) {
    const { GamePeriod } = event
    const { getMatchPeriods, getWinner } = this

    if (getWinner === 'draft') return

    const { type, overriddenType } = getMatchPeriods[GamePeriod]

    if (overriddenType === 'shootout') return this.$t('trader.win.bullets')

    if (type === 'overtime') return this.$t('trader.win.overtime')

    return this.$t('trader.win.maintime')
  }
}
